import React from "react";

const ProjectTeamTab = ({
  teamData,
  teamMemberDetails,
  loadingTeamMembers,
  getUserDisplayInfo,
}) => {
  return (
    <div className="project-view-fade-in">
      <div className="project-overview-single-card">
        <div className="d-flex justify-content-between align-items-center mb-4">
          {loadingTeamMembers && (
            <div className="text-muted">
              <small>Loading team members...</small>
            </div>
          )}
        </div>

        {teamData ? (
          <div className="project-view-team-details-container">
            <div className="project-view-overview-grid">
              <div className="project-view-overview-row">
                <span className="project-view-overview-label">Team Name:</span>
                <span className="project-view-overview-value">
                  {teamData.teamName}
                </span>
                <span className="project-view-overview-label">Team ID:</span>
                <span className="project-view-overview-value">
                  {teamData.teamId}
                </span>
              </div>

              {/* Team Members Section */}
              <div
                className="project-view-overview-row"
                style={{ display: "block" }}
              >
                <span className="project-view-overview-label">
                  Team Members:
                </span>
                <div className="team-members-grid mt-3">
                  {teamData.teamMembers && teamData.teamMembers.length > 0 ? (
                    teamData.teamMembers.map((memberId, index) => {
                      const userInfo = getUserDisplayInfo(memberId);
                      return (
                        <div key={index} className="team-member-card">
                          <div className="project-view-team-member-avatar">
                            <i className="fas fa-user"></i>
                          </div>
                          <div className="team-member-info">
                            <div className="team-member-name">
                              {userInfo.name}
                            </div>
                            <div className="team-member-email">
                              {userInfo.email}
                            </div>
                            <div className="team-member-id">
                              <small className="text-muted">
                                ID: {memberId}
                              </small>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="text-center py-4 text-muted">
                      <i className="fas fa-users fa-2x mb-3"></i>
                      <p>No team members found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-5">
            <div className="no-team-placeholder">
              <i className="fas fa-users fa-3x text-muted mb-3"></i>
              <h5 className="text-muted">No Team Assigned</h5>
              <p className="text-muted mb-3">
                This project doesn't have a team assigned yet.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectTeamTab;
